import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronIcon } from '../icons/SalesIcons';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿No tengo experiencia previa, puedo tomar el curso?',
    answer: 'El curso empieza desde cero absoluto. El módulo 1 te orienta antes de tocar cualquier material. Está diseñado específicamente para principiantes que quieren bases sólidas.'
  }, {
    question: '¿Necesito un espacio especial para hacer velas?',
    answer: 'No. Puedes empezar en tu cocina con una olla y los materiales básicos que se detallan en el módulo 2. No necesitas un taller profesional.'
  }, {
    question: '¿Qué pasa si tengo dudas durante el curso?',
    answer: 'Tienes acceso a comunidad privada de WhatsApp y Telegram donde Stefany y la comunidad responden. No estarás sola en ningún momento del proceso.'
  }, {
    question: '¿Y si ya sé hacer velas básicas?',
    answer: 'Desde el módulo 9 en adelante encontrarás técnicas avanzadas que muy pocos cursos enseñan: velas marmolizadas, repostería, flores preservadas, y más.'
  }, {
    question: '¿Cuánto tiempo necesito dedicar por día?',
    answer: 'El curso es 100% online y a tu ritmo. Puedes avanzar en los momentos que tú elijas. No hay fechas límite ni presión.'
  }, {
    question: '¿Sirve para emprender un negocio real?',
    answer: 'Sí. Los bonos 3 y 4 (plantilla de costos y lista de proveedores) están diseñados específicamente para que puedas vender con ganancia real desde el principio.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#FDF8F4] py-16 md:py-24" data-id="element-138">
      <div className="max-w-3xl mx-auto px-4" data-id="element-139">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-140">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#5C4033] mb-4" data-id="element-141">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-[#2D2926]" data-id="element-142">Resolvemos tus dudas</p>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="space-y-4" data-id="element-143">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-md border border-[#C4A882]/20 overflow-hidden" data-id="element-144">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-[#C4A882] focus:ring-inset" aria-expanded={openIndex === index} data-id="element-145">
                <span className="font-heading text-lg text-[#5C4033] pr-4" data-id="element-146">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-147">
                  <ChevronIcon size={24} className="text-[#9B2335]" data-id="element-148" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-149">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-150">
                    <div className="px-6 pb-5 text-[#2D2926] leading-relaxed border-t border-[#C4A882]/20 pt-4" data-id="element-151">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}